














/* eslint-disable @typescript-eslint/no-explicit-any */
import CtrlSearchCommonComponents from '@/components/common/control/CtrlSearchCommonComponents.vue';
import Vue from 'vue';
import { UmuFlg } from '@/constants/constants';

export default Vue.extend({
  name: 'ListHimmoku',
  components: {
    CtrlSearchCommonComponents,
  },
  props: {
    mitsumoriUmuFlg: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    UmuFlg,
    headers: [
      {
        text: 'コード',
        sortable: true,
        value: 'himmokuCd',
        width: 80,
      },
      {
        text: '名称',
        sortable: true,
        value: 'himmokuMei',
        width: 510,
      },
    ],
    formatColName: 'himmokuCd',
    filterGroupKey: 0,
    apiParams: {} as any,
  }),
  methods: {
    // 初期化
    getParams() {
      // [this.apiParams = {}] の代入元として使う為、[this.$props] を const 化する
      const {
        mitsumoriUmuFlg,
        himmokuShuruiPtn,
        gyoshuCd,
        uriageKahiKb,
        zaikoKanriKb,
        shiiresakiCd,
        genryoShiiresakiCd,
        jigyoshoCd,
        tokuisakiCd,
        nohinsakiCd,
        haisoKb,
        mukoUmuFlg,
      } = this.$attrs;

      // object の分割代入
      // 自分自身(this.apiParams) を代入する
      // [this.$attrs] を const 化した値を [this.apiParams] に代入する
      this.apiParams = {
        mitsumoriUmuFlg,
        himmokuShuruiPtn,
        gyoshuCd,
        uriageKahiKb,
        zaikoKanriKb,
        shiiresakiCd,
        genryoShiiresakiCd,
        jigyoshoCd,
        tokuisakiCd,
        nohinsakiCd,
        haisoKb,
        mukoUmuFlg,
      };

      if (
        this.apiParams.shiiresakiCd === 0 ||
        this.apiParams.shiiresakiCd === undefined ||
        this.apiParams.shiiresakiCd.length === 0
      ) {
        delete this.apiParams.shiiresakiCd;
      }
      if (
        this.apiParams.genryoShiiresakiCd === 0 ||
        this.apiParams.genryoShiiresakiCd === undefined ||
        this.apiParams.genryoShiiresakiCd.length === 0
      ) {
        delete this.apiParams.genryoShiiresakiCd;
      }
      if (
        this.apiParams.jigyoshoCd === 0 ||
        this.apiParams.jigyoshoCd === undefined ||
        this.apiParams.jigyoshoCd.length === 0
      ) {
        delete this.apiParams.jigyoshoCd;
      }
      if (
        this.apiParams.tokuisakiCd === 0 ||
        this.apiParams.tokuisakiCd === undefined ||
        this.apiParams.tokuisakiCd.length === 0
      ) {
        delete this.apiParams.tokuisakiCd;
      }
      if (
        this.apiParams.nohinsakiCd === 0 ||
        this.apiParams.nohinsakiCd === undefined ||
        this.apiParams.nohinsakiCd.length === 0
      ) {
        delete this.apiParams.nohinsakiCd;
      }
      if (this.mitsumoriUmuFlg) {
        this.apiParams.mitsumoriUmuFlg = UmuFlg.ARI;
        this.headers.push(
          {
            text: '得意先品目コード',
            sortable: true,
            value: 'aiteHimmokuCd',
            width: 150,
          }
        );
      } else {
        this.apiParams.mitsumoriUmuFlg = UmuFlg.NASHI;
      }
      // 2022/10/25 CD が未指定の場合、要素を削除する e
    },
  },
  created() {
    this.getParams();
  },
});
